import reviewProcessedPage from "~/store/graphql/queries/reviewProcessedPage.graphql";

import runGraphQLQuery from "~/store/manage/utilities/runGraphQLQuery";

const loadReviewProcessed = async function (
  { commit, dispatch },
  { req, res, params }
) {
  commit("START_LOADING");
  const data = await runGraphQLQuery(
    reviewProcessedPage,
    params,
    this.$axios,
    req,
    res
  );

  const featureToggles = {
    multipleCategoriesSubmission: this.$unleash.isEnabled(
      "multipleCategoriesSubmission"
    ),
  };

  commit("SET_REVISION_WORKFLOW", { payload: data, featureToggles });
  dispatch("validateSubmission");
  commit("END_LOADING");

  return data;
};

export default loadReviewProcessed;
